@import "src/style/lib";

button.a {
  appearance: none;
  display: inline;
  background: none;
  border: none;
  padding: 0;
  padding-block: 0;
  padding-inline: 0;
  font: inherit;
  outline: none;
  outline-offset: 1px;
  transition: color 0.3s;
  line-height: inherit;
  text-align: start;
  cursor: pointer;
  color: $link-color;
  text-decoration: $link-decoration;
  &:hover {
    color: $link-hover-color;
    text-decoration: $link-hover-decoration;
  }
  &:focus-visible {
    box-shadow: none;
    outline: 2px solid #e6a94e;
  }
}
